import { OPEN_COVERAGE_FORM_MODAL } from '../actionTypes';
import { configurationCoveragesActions } from '../reducer';

import resetCoverageForm from './resetCoverageForm';

export default (value) => (dispatch) => {
    dispatch(configurationCoveragesActions[OPEN_COVERAGE_FORM_MODAL](value));
    if (!value) dispatch(resetCoverageForm());
};
